/**
 * 工伤单位
 */

import {
  get,
  post,
  put,
  del
} from '@/util/request'
import download from "@/util/download";

/**
 * 根据Id查询
 * @param {*} Id
 * @returns
 */
export const SelectInjuryUnitById = (Id) => {
  return get('/api/app/injuryUnit?CurrentId=' + Id);
}

/**
 * 新增数据记录
 * @param {*} data
 * @returns
 */
export const AddInjuryUnit = (data) => {
  return post('/api/app/injuryUnit', data, {});
}

/**
 * 更新数据记录
 * @param {*} data
 * @returns
 */
export const ModifyInjuryUnit = (data) => {
  return put('/api/app/injuryUnit', data, {});
}

/**
 * 分页获取所属行业
 * @param {*} data
 * @returns
 */
export const GetDataInjuryUnitList = (data) => {
  return post('/api/app/injuryUnit/list', data, {});
}

/**
 * 删除记录
 * @param {*} id
 * @returns
 */
export const DeleteInjuryUnit = (id) => {
  return del('/api/app/injuryUnit/' + id, {}, {});
}

/**
 * 导出Excel
 * @param {*} id
 * @returns
 */
 export const ExportInjuryUnit = (data) => {
  let defaluturl = `/api/app/InjuryUnit/exportExcelFile`;
  let fileName = "工伤单位"
  return download(fileName, defaluturl, data);
}